import {Component} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';

/**
 * board-block
 */
export class BoardBlock extends Component {
    static TypeName = 'board-block';

    @property.int(3)
    boardsNumber = 3;
    boardFallCount = 0;

    start() {
        /* General */
        this.boardFallCount = 0;
    }

    boardFall() {
        this.boardFallCount += 1;
        if (this.boardFallCount == this.boardsNumber) {
            setTimeout(() => this.object.destroy(), 1); /* Destroy the Block */
        }
    }
}
